import { render, staticRenderFns } from "./CoordinateInstallation.vue?vue&type=template&id=659b1e61&"
import script from "./CoordinateInstallation.vue?vue&type=script&lang=js&"
export * from "./CoordinateInstallation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports